import type { PersonalDetails } from "../data/profile";
import type { OpenProfileOverlay } from "../overlays/profileOverlay";
import {
    FieldList,
    HighlightBanner,
    ProfileParagraph,
    ProfileSection,
} from "../profilePrimitives";
import { personalMissing, personalRows } from "../profileRows";

export function PersonalSection({
    personal,
    setOverlay,
}: {
    personal: PersonalDetails;
    setOverlay: OpenProfileOverlay;
}) {
    return (
        <ProfileSection
            title="Personal information"
            editable
            onEdit={() => setOverlay({ type: "edit", section: "personal" })}
        >
            {personal.personalHighlight && (
                <HighlightBanner title={personal.personalHighlight} />
            )}
            {personal.personalMustKnow && (
                <ProfileParagraph>{personal.personalMustKnow}</ProfileParagraph>
            )}
            <FieldList
                rows={personalRows(personal)}
                missing={personalMissing(personal)}
            />
        </ProfileSection>
    );
}
